import { AppModalType } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/AppDownload";
import { QRAppSection } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/QRAppSection";
import { TextAppSection } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/TextAppSection";
import { trackRetailerMobileFooterDesktopappModalandroidScanQrCodeTabClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalAndroidScanQrCodeTab";
import { trackRetailerMobileFooterDesktopappModalandroidTextMeTabClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalAndroidTextMeTab";
import { trackRetailerMobileFooterDesktopappModaliosScanQrCodeTabClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalIosScanQrCodeTab";
import { trackRetailerMobileFooterDesktopappModaliosTextMeTabClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalIosTextMeTab";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Modal } from "@faire/web/slate/deprecated/Modal";
import { Tabs, Tab } from "@faire/web/slate/deprecated/Tabs";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

interface IProps {
  appModalType: AppModalType;
  onClose: () => void;
}

enum DownloadMethodsEnum {
  QR = "QR",
  TEXT = "TEXT",
}

const useTabs = (): Tab<DownloadMethodsEnum>[] => {
  const { strictLocalize } = useStrictLocalization();
  return [
    {
      value: DownloadMethodsEnum.QR,
      label: strictLocalize({
        id: "ffxQWT",
        defaultMessage: "Scan QR Code",
        description: {
          text: "Tab header to show scan QR code option to download the Faire app",
          img: "https://cdn.faire.com/fastly/aacb3261706fd76b7288bb0596397b81c74108054373e7e547cb1f1be36f8f12.png",
        },
      }),
    },
    {
      value: DownloadMethodsEnum.TEXT,
      label: strictLocalize({
        id: "Y/dNDc",
        defaultMessage: "Text me",
        description: {
          text: "Tab header to show text (sms) message option to download the Faire app",
          img: "https://cdn.faire.com/fastly/aacb3261706fd76b7288bb0596397b81c74108054373e7e547cb1f1be36f8f12.png",
        },
      }),
    },
  ];
};

export const LoggedOutAppDownloadModal: React.FC<IProps> = (props) => {
  const tabs = useTabs();
  const [activeDownloadMethodTab, setDownloadMethodActiveTab] = React.useState(
    DownloadMethodsEnum.QR
  );

  const trackAndSetNewTab = (newTab: DownloadMethodsEnum) => {
    setDownloadMethodActiveTab(newTab);
    if (newTab === DownloadMethodsEnum.QR) {
      trackQRCodeTabClicked();
    } else {
      trackTextMeTabClicked();
    }
  };

  const trackQRCodeTabClicked = () => {
    if (props.appModalType === AppModalType.APPSTORE) {
      trackRetailerMobileFooterDesktopappModaliosScanQrCodeTabClick();
    } else {
      trackRetailerMobileFooterDesktopappModalandroidScanQrCodeTabClick();
    }
  };

  const trackTextMeTabClicked = () => {
    if (props.appModalType === AppModalType.APPSTORE) {
      trackRetailerMobileFooterDesktopappModaliosTextMeTabClick();
    } else {
      trackRetailerMobileFooterDesktopappModalandroidTextMeTabClick();
    }
  };

  return (
    <Modal
      onClose={props.onClose}
      width="400px"
      height="auto"
      padding={getSpacing(96, "3x", "3x")}
    >
      <Typography
        variant="pageHeaderSerifRegular"
        style={{ alignSelf: "flex-start" }}
      >
        <StrictLocalMsg
          id="YUtjdv"
          defaultMessage="Get the Faire app"
          description={{
            text: "Prompt for user to download the Faire app",
            img: "https://cdn.faire.com/fastly/8886233fe3a21ea9f5606277d4f3fd86f785f0c8c7dd8b8bcbc9b4d79727528c.png",
          }}
        />
      </Typography>
      <Spacer height="3x" />
      <Tabs
        tabs={tabs}
        activeTab={activeDownloadMethodTab}
        onTabChange={(newTab: DownloadMethodsEnum) => trackAndSetNewTab(newTab)}
      />
      <Spacer height="2x" />
      {activeDownloadMethodTab === DownloadMethodsEnum.QR ? (
        <QRAppSection appModalType={props.appModalType} />
      ) : (
        <TextAppSection
          appModalType={props.appModalType}
          onClose={props.onClose}
          loggedOut
        />
      )}
    </Modal>
  );
};
